import CustomerInitForm from '../../components/wirepas/wirepas.customer.init';
import { Container, Box } from '@mui/material';

function WirepasPage() {
  return (
    <Container maxWidth="lg">
      <Box my={4}>
        <CustomerInitForm />
      </Box>
    </Container>
  );
}

export default WirepasPage;
